export default "__VITE_ASSET__xWBvne7b__"